import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    padding: 20,
    flexDirection: 'column',
    '& .premise' : {
      marginTop: 5,
    },
    '& .answer' : {
      marginTop: 15,
    }
  },
}))

export {useStyles as default}
